import MarketingTagsList from "../../../productCard/common/MarketingTagsList";
import TableCell from "../../../TableCell";
import React from 'react';

import { createStyles } from "./styles";
































var MarketingCell = function MarketingCell(_ref)





{var marketingTagIds = _ref.marketingTagIds,portfolioId = _ref.portfolioId,marketingTags = _ref.marketingTags,columnsAmount = _ref.columnsAmount,showWideColumns = _ref.showWideColumns;
  var classes = createStyles({ columnsAmount: columnsAmount, showWideColumns: showWideColumns });
  return /*#__PURE__*/(
    React.createElement(TableCell, { className: classes.marketingCell }, /*#__PURE__*/
    React.createElement(MarketingTagsList, {
      marketingTagIds: marketingTagIds,
      marketingTags: marketingTags,
      portfolioId: portfolioId,
      listStyles: classes.tagsList })));



};

export default MarketingCell;
//# sourceMappingURL=index.js.map